import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AjaxService } from '../core';
import { CoreModule } from '../core/core.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { FormlyModule } from '@ngx-formly/core';
import { FieldWrapperComponent } from './wrappers/field-wrapper.component';
import { RouterModule } from '@angular/router';
import { DYNAMIC_FORM_CONFIG } from './form-config';
import { LoginScreenComponent } from './components/login-screen/login-screen.component';
import { LoginWrapperComponent } from './components/login-screen/login-wrapper.component';
import { FileUploadComponent } from './components/form/file-upload/file-upload.component';
import { FileValueAccessor } from './components/form/file-upload/file-upload-value-accessor';
import { ActiveCasesListComponent } from './components/active-cases-list/active-cases-list.component';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { TextAreaComponent } from './components/form/text-area/text-area.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownComponent } from './components/form/dropdown/dropdown.component';
import { DropdownModule } from 'primeng/dropdown';
import { PatientComponent } from './components/register-forms/patient/patient.component';
import { ClinicianComponent } from './components/register-forms/clinician/clinician.component';
import { ConsultantComponent } from './components/register-forms/consultant/consultant.component';
import { AdminComponent } from './components/register-forms/admin/admin.component';
import { FormlySelectModule as FormlyCoreSelectModule } from '@ngx-formly/core/select';
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { PasswordComponent } from './components/form/password/password.component';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from "primeng/divider";
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ButtonTypeComponent } from './components/form/button/button-type.component';
import { LabelComponent } from './components/form/label/label.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AddressComponent } from './components/form/address/address.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpGenerateComponent } from './components/form/otp-generate/otp-generate.component';
import { RichTextEditorComponent } from './components/form/rich-text-editor/rich-text-editor.component';
import { EditorModule } from 'primeng/editor';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import {RadioButtonModule} from 'primeng/radiobutton';
import { SuperadminFormComponent } from './components/register-forms/superadmin-form/superadmin-form.component';
import {MenubarModule} from 'primeng/menubar';
import {MultiSelectModule} from 'primeng/multiselect';
import { MultiSelectDropdownComponent } from './components/form/multi-select-dropdown/multi-select-dropdown.component';
import { DatePickerComponent } from './components/form/date-picker/date-picker.component';
import { LoginWrapper1Component } from './components/login-screen/login-wrapper1.component';
import {ChipsModule} from 'primeng/chips';
import { ChipsComponent } from './components/form/chips/chips.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonTableGridComponent } from './components/common-table-grid/common-table-grid.component';
import { TableModule } from 'primeng/table';
import { PatientsCommonTableGridComponent } from './components/patients-common-table-grid/patients-common-table-grid.component';
import { CalendarModule } from 'primeng/calendar';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    TableModule,
    CoreModule,
    NgxPermissionsModule,
    FormlyPrimeNGModule,
    CheckboxModule,
    RadioButtonModule,
    TooltipModule,
    FileUploadModule,
    InputTextareaModule,
    DropdownModule,
    PaginatorModule,
    DialogModule,
    PasswordModule,
    DividerModule,
    ButtonModule,
    RippleModule,
    FormlyCoreSelectModule,
    GooglePlaceModule,
    NgOtpInputModule,
    EditorModule,
    ConfirmDialogModule,
    FormlyModule.forRoot(DYNAMIC_FORM_CONFIG),
    MenubarModule,
    MultiSelectModule,
    ChipsModule,
    CalendarModule
  ],
  exports: [
    TranslateModule,
    NgxPermissionsModule,
    TableModule,
    LoginScreenComponent,
    FormlyModule,
    ReactiveFormsModule,
    ActiveCasesListComponent,
    CommonTableGridComponent,
    PatientsCommonTableGridComponent,
    PatientComponent,
    ClinicianComponent,
    ConsultantComponent,
    AdminComponent,
    DropdownModule,
    PaginatorModule,
    CheckboxModule,
    RadioButtonModule,
    DialogModule,
    PasswordModule,
    DividerModule,
    ButtonModule,
    RippleModule,
    GooglePlaceModule,
    EditorModule,
    NgOtpInputModule,
    ConfirmDialogModule,
    SuperadminFormComponent,
    MultiSelectModule,
    TooltipModule,
    ChipsModule,
    HeaderComponent,
    FooterComponent,
    CalendarModule
  ],
  declarations: [
    LoginScreenComponent,
    LoginWrapperComponent,
    FieldWrapperComponent,
    FileUploadComponent,
    FileValueAccessor,
    ActiveCasesListComponent,
    TextAreaComponent,
    DropdownComponent,
    PatientComponent,
    ClinicianComponent,
    ConsultantComponent,
    AdminComponent,
    PasswordComponent,
    ButtonTypeComponent,
    LabelComponent,
    AddressComponent,
    OtpGenerateComponent,
    RichTextEditorComponent,
    SuperadminFormComponent,
    MultiSelectDropdownComponent,
    LoginWrapper1Component,
    ChipsComponent,
    HeaderComponent,
    FooterComponent,
    CommonTableGridComponent,
    PatientsCommonTableGridComponent,
    DatePickerComponent
  ],
  providers: [
    AjaxService
  ],
  entryComponents: [
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
      ]
    };
  }
}
